"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("@lingui/react");
var _haAdobeDotcomLoggerUtil = require("@adsk/ha-adobe-dotcom-logger-util");
var _formControl = _interopRequireDefault(require("@digital-hig/form-control"));
var _core = require("@lingui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TextArea = _interopRequireDefault(require("./TextArea"));
var _Radio = _interopRequireDefault(require("@mui/material/Radio"));
var _RadioGroup = _interopRequireDefault(require("@mui/material/RadioGroup"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// i18n need to be in a function to translate.
var opts = function opts() {
  var translatedRadios = [{
    value: 'Quality',
    label: _core.i18n._( /*i18n*/_core.i18n._("The information was difficult to understand"))
  }, {
    value: 'Findability',
    label: _core.i18n._( /*i18n*/_core.i18n._("It wasn't what I was looking for"))
  }, {
    value: 'Incomplete',
    label: _core.i18n._( /*i18n*/_core.i18n._("It didn't address my needs"))
  }, {
    value: 'Other',
    label: _core.i18n._( /*i18n*/_core.i18n._("Something else"))
  }];
  return translatedRadios;
};
var NotHelpfulFeedback = function NotHelpfulFeedback(props) {
  var logToAdp = props.logToAdp;
  var _useState = (0, _react2.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    radioValue = _useState2[0],
    setRadioValue = _useState2[1];
  var _useState3 = (0, _react2.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    userComment = _useState4[0],
    setUserComment = _useState4[1];
  var _useState5 = (0, _react2.useState)(opts),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 1),
    options = _useState6[0];
  var handleRadioChange = function handleRadioChange(event) {
    var value = event.currentTarget.value;
    setRadioValue(value);
    setUserComment('');
  };
  var handleUserCommentChange = function handleUserCommentChange(event) {
    var value = event.target.value;
    setUserComment(value);
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var payload = {
      ev: 'false',
      hi: radioValue,
      uc: userComment
    };
    logToAdp('helpful_comment', payload);
    var aaNoRadio = (0, _haAdobeDotcomLoggerUtil.adobeLinkClickObject)({
      section: 'content helpfulness',
      title: radioValue
    });
    (0, _haAdobeDotcomLoggerUtil.adobeSendData)(aaNoRadio);
  };
  return /*#__PURE__*/_react2.default.createElement("form", {
    className: "wtih-feedback",
    onSubmit: handleSubmit,
    "data-testid": "not-helpful-feedback"
  }, /*#__PURE__*/_react2.default.createElement("div", {
    className: "dhig-pb-7 dhig-theme--light"
  }, /*#__PURE__*/_react2.default.createElement("div", {
    className: "dhig-mb-3"
  }, /*#__PURE__*/_react2.default.createElement(_formControl.default, {
    component: "fieldset",
    className: "dhig-w-full",
    label: _core.i18n._( /*i18n*/_core.i18n._("Why wasn't this information helpful?")),
    InputLabelProps: {
      component: 'legend'
    }
  }, /*#__PURE__*/_react2.default.createElement(RadioGroupWrapper, {
    className: "MuiFormGroup-root",
    id: "not-helpful-feedback"
  }, options.map(function (opt) {
    return /*#__PURE__*/_react2.default.createElement("div", {
      key: "key__".concat(opt.value)
    }, /*#__PURE__*/_react2.default.createElement(_FormControlLabel.default, {
      className: "radio__label",
      value: opt.value,
      checked: opt.value === radioValue,
      control: /*#__PURE__*/_react2.default.createElement(_Radio.default, {
        size: "medium"
      }),
      label: opt.label,
      onChange: handleRadioChange
    }), opt.value === radioValue ? /*#__PURE__*/_react2.default.createElement(TextAreaWrapper, null, /*#__PURE__*/_react2.default.createElement(_TextArea.default, {
      label: _core.i18n._( /*i18n*/_core.i18n._("Please tell us why")),
      placeholder: _core.i18n._( /*i18n*/_core.i18n._("NOTE: Your comments here can only be seen by our editor")),
      id: "wtih-textarea__".concat(opt.value),
      onChange: handleUserCommentChange,
      value: userComment
    })) : null);
  })))), /*#__PURE__*/_react2.default.createElement("button", {
    type: "submit",
    className: "MuiButtonBase-root MuiButton-root MuiButton-contained",
    disabled: userComment === ''
  }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "Submit feedback"
  }))));
};
var TextAreaWrapper = _styledComponents.default.div.withConfig({
  displayName: "NotHelpfulFeedback__TextAreaWrapper",
  componentId: "ha-__sc-4e2ngt-0"
})(["margin-left:20px !important;margin-bottom:24px;"]);
var RadioGroupWrapper = (0, _styledComponents.default)(_RadioGroup.default).withConfig({
  displayName: "NotHelpfulFeedback__RadioGroupWrapper",
  componentId: "ha-__sc-4e2ngt-1"
})(["margin-left:10px;svg.MuiSvgIcon-root{font-size:21px !important;}"]);
NotHelpfulFeedback.propTypes = {
  logToAdp: _propTypes.default.func
};
NotHelpfulFeedback.defaultProps = {
  logToAdp: {}
};
var _default = NotHelpfulFeedback;
exports.default = _default;